export function YtKontrolaEmail(email: string) : boolean{
    if (email == null)
        return null;
    else{    
        let regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/g);
        let test : boolean = regex.test(email);
        return test;
    }
}